module.exports = __webpack_public_path__ + "img/5 - Leon Wessels.014221e8.jpg";